import { EntityTracking } from '@bark/bark-core';

const isDebug = () => new URL(window.location.href).searchParams.get('debug') === '1';

const entityTracking = new EntityTracking({ nameFormat: 'title', debug: isDebug() });

let BookingDetailsDispatch = undefined;
const bookingIdDockId = '__rctBookingDetailsContainer';

export function onBookingPageInit() {
	// entityTracking.createEntities([
	// 	{
	// 		id: 'project',
	// 		data: {
	// 			project_id: brData.projectId,
	// 			category_id: brData.categoryId,
	// 		},
	// 	},
	// 	{
	// 		id: 'seller_profile',
	// 		data: brData.sellerProfileEntity,
	// 	},
	// ]);
	// entityTracking.createEvents([
	// 	{
	// 		id: 'cta_click',
	// 		name: 'Page CTA Event',
	// 		entities: ['page', 'seller_job'],
	// 		group: 'Seller Responses Page',
	// 	},
	// 	{
	// 		id: 'page_load',
	// 		name: 'Page Load',
	// 		entities: ['page'],
	// 		group: 'Seller Responses Page',
	// 	},
	// ]);
}

export function launchBookingDetails(bookingDetails) {

	if (!bookingDetails?.customer_order) return;

	const container = $(`#${bookingIdDockId}`);

	if (BookingDetailsDispatch && container.children().length) {
		BookingDetailsDispatch({
			type: 'SET_BOOKING_DETAILS',
			payload: bookingDetails,
		});
	} else {
		window.SellerResponsesApp.launchModule(
			'booking-response-details-item',
			bookingIdDockId,
			{
				sellerId: window.Bark.seller.id,
				tracking: entityTracking,
				onMount: (dispatch) => {
					BookingDetailsDispatch = dispatch;
					BookingDetailsDispatch({
						type: 'SET_BOOKING_DETAILS',
						payload: bookingDetails,
					});
				},
			},
		);
	}
}
